export abstract class Language {
  public abstract readonly name: string;

  /**
   * @param {String} text The string to parsed into words.
   * @return {Word[]} the resulting parsed words from syllabification
   */
  public syllabify(text: string) {
    if (text === '') {
      return [];
    }

    // Divide the text into words separated by whitespace
    const words = text.split(/[\s]+/);
    return words.map((word) => this.syllabifyWord(word));
  }

  abstract syllabifyWord(word: string): string[];

  abstract findVowelSegment(s: string, startIndex: number): { found: boolean, startIndex: number, length: number };
}
